import {Component, inject, OnInit, signal} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToastMessageOptions } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CheckIcon, ExclamationTriangleIcon, InfoCircleIcon, TimesCircleIcon } from 'primeng/icons';
import {environment} from '../environments/environment';
import { ToastLink } from './models/toast-link';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, CheckIcon, ExclamationTriangleIcon, InfoCircleIcon, TimesCircleIcon],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('yaldi-dashboard');

  private router = inject(Router);

  ngOnInit() {

    const script = document.createElement('script');

      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}&libraries=marker&v=weekly&loading=async`;

    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  openToastLink(message: ToastMessageOptions) {
    const link: ToastLink | undefined = message.data?.link;
    if (!link) return;
    this.router.navigate([link.path], { queryParams: link.queryParams });
  }
}
